var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.609 1H7.391C3.387 1 1 3.387 1 7.391V16.598C1 20.613 3.387 23 7.391 23H16.598C20.602 23 22.989 20.613 22.989 16.609V7.391C23 3.387 20.613 1 16.609 1ZM17.258 9.47L11.021 15.707C10.867 15.861 10.658 15.949 10.438 15.949C10.218 15.949 10.009 15.861 9.855 15.707L6.742 12.594C6.423 12.275 6.423 11.747 6.742 11.428C7.061 11.109 7.589 11.109 7.908 11.428L10.438 13.958L16.092 8.304C16.411 7.985 16.939 7.985 17.258 8.304C17.577 8.623 17.577 9.14 17.258 9.47Z",
    fill: "#253D87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconChecked);
export default __webpack_public_path__ + "static/media/common_icon_checked.374acde54b04c5781f195aafd61ea682.svg";
export { ForwardRef as ReactComponent };